import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { useCart } from "@/contexts/CartContext";

const CheckoutReturn = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const { clear } = useCart();

  useEffect(() => {
    if (sessionId) clear();
  }, [sessionId, clear]);

  return (
    <div className="min-h-screen">
      <Navigation />
      <main className="container mx-auto px-4 pt-32 md:pt-40 pb-16">
        <Card className="max-w-2xl mx-auto p-10 text-center glass-effect border-[hsl(var(--line))]">
          <CheckCircle2 className="h-16 w-16 mx-auto mb-4 text-primary" />
          <h1 className="font-orbitron font-bold text-3xl mb-3">Payment Successful</h1>
          <p className="text-muted-foreground mb-6">
            Thank you for your order. A confirmation email is on the way with your receipt and shipping details.
          </p>
          {sessionId && (
            <p className="text-xs text-muted-foreground mb-6 break-all">
              Order reference: {sessionId}
            </p>
          )}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild>
              <Link to="/accessories">Continue Shopping</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/">Back to Home</Link>
            </Button>
          </div>
        </Card>
      </main>
      <Footer />
    </div>
  );
};

export default CheckoutReturn;
